import * as S from "./styles.ts";
import { Star } from "@template/icons";

const Stars = () => {
  const starSize = 18;
  return (
    <S.StarsContainer>
      <Star
        width={starSize}
        height={starSize}
      />
      <Star
        width={starSize}
        height={starSize}
      />
      <Star
        width={starSize}
        height={starSize}
      />
      <Star
        width={starSize}
        height={starSize}
      />
      <Star
        width={starSize}
        height={starSize}
      />
    </S.StarsContainer>
  );
};

export default Stars;
